import React, { useCallback, useEffect } from 'react';

import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import UsersListBig from '../../../../components/reusable/users-list/UsersListBig';
import {
  useGetMyDetails,
  useLazyGetUserSubscriptions,
} from '../../../../redux/api/users/usersApi';

export default function MySubscriptions() {
  const { data: user, isFetching: isFetchingUser } = useGetMyDetails();
  const [
    getUserSubscriptions,
    { data: userSubscriptions, isError, error: userSubscriptionsError },
  ] = useLazyGetUserSubscriptions();

  useEffect(() => {
    if (user) {
      getUserSubscriptions(user.id);
    }
  }, [user?.id]);

  const refreshList = useCallback(() => {
    if (user?.id) void getUserSubscriptions(user.id);
  }, [user?.id, getUserSubscriptions]);

  const isListLoading =
    Boolean(isFetchingUser) || !user || userSubscriptions === undefined;

  useRegisterPageContainerError({
    errors: isError && userSubscriptionsError ? [userSubscriptionsError] : [],
    isLoading: isListLoading,
    hasData: Boolean(userSubscriptions),
    onRetry: refreshList,
  });

  return (
    <UsersListBig
      users={userSubscriptions}
      showSearch
      isLoading={isListLoading}
      isError={isError}
    />
  );
}
